import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { RetiroHistorialList } from './RetiroHistorialList';
import type { OtroTramiteRecord } from '../../types';

interface ViewRetiroDialogProps {
  open: boolean;
  tramite: OtroTramiteRecord;
  onOpenChange: (open: boolean) => void;
}

export const ViewRetiroDialog: React.FC<ViewRetiroDialogProps> = ({
  open,
  tramite,
  onOpenChange,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-4xl max-h-[90dvh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>Historial de retiros del tramite {tramite.id}</DialogTitle>
        <DialogDescription>
          Consulte el detalle de los retiros registrados para este tramite completo.
        </DialogDescription>
      </DialogHeader>

      <RetiroHistorialList
        otroTramiteId={tramite.id}
        copiasDisponibles={tramite.copiasTotales - tramite.copiasActuales}
      />
    </DialogContent>
  </Dialog>
);
